import React from 'react';
import { MetricsElement } from "react-metrics";
import { Element as ReactScrollElement } from 'react-scroll';

import Accordion from '../../../shared/components/accordion';
import { ErrorBoundary } from '../../../shared/components/error-boundary';

export default ({ tabIndex, tabs, product, device, handleTabChange }) => {
    return (
        <ReactScrollElement name='pdpTabs' className='pdp-mobile-tabs'>
            {
                tabs.map((tab, i) => {
                    const { prefetch } = tab;
                    const MetricsWrapper = ({content}) =>{
                        return(
                            <MetricsElement
                                element="div"
                                data-metrics-event-name = { tab.trackName }
                                data-metrics-event = {`e_${ tab.trackName }`}
                                data-metrics-product-name = { product.name }
                                data-metrics-details-tab-name = { tab.name }
                            >{content}</MetricsElement>
                        )
                    }
                    return(
                        <Accordion 
                            key={i} 
                            accordionKey={i} 
                            title={tab.name} 
                            lazyLoad={true} 
                            MetricsWrapper={MetricsWrapper} 
                            prefetch={prefetch}
                            tabIndex={tabIndex} handleTabChange={handleTabChange}>
                            <ErrorBoundary>
                                {tab.component({product, device,})}
                            </ErrorBoundary>
                        </Accordion>
                    )
                })
            }
        </ReactScrollElement>
    )
}
